import { useState } from 'react';
import { OpsLayout } from '@/components/ops/OpsLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SurgeonStatusTracker } from '@/components/admin/orchestrator/SurgeonStatusTracker';
import { BundleManagement } from '@/components/admin/orchestrator/BundleManagement';
import { CredentialingVault } from '@/components/admin/orchestrator/CredentialingVault';
import { CommunicationHub } from '@/components/admin/orchestrator/CommunicationHub';
import { LayoutDashboard, Package, ShieldCheck, Bell } from 'lucide-react';

export default function AdminOrchestratorPage() {
  return (
    <OpsLayout>
      <div className="p-6 space-y-6 max-w-7xl mx-auto">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <LayoutDashboard className="w-6 h-6 text-primary" />
            Administrative Orchestrator
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Medical Group Manager — Workflow, Bundles, Credentials & Notifications
          </p>
        </div>

        <Tabs defaultValue="status" className="space-y-4">
          <TabsList className="grid w-full grid-cols-4 h-auto">
            <TabsTrigger value="status" className="flex items-center gap-1.5 text-xs sm:text-sm py-2">
              <LayoutDashboard className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">Status</span> Tracker
            </TabsTrigger>
            <TabsTrigger value="bundles" className="flex items-center gap-1.5 text-xs sm:text-sm py-2">
              <Package className="w-3.5 h-3.5" />
              Bundle<span className="hidden sm:inline"> Library</span>
            </TabsTrigger>
            <TabsTrigger value="credentials" className="flex items-center gap-1.5 text-xs sm:text-sm py-2">
              <ShieldCheck className="w-3.5 h-3.5" />
              Credential<span className="hidden sm:inline"> Vault</span>
            </TabsTrigger>
            <TabsTrigger value="comms" className="flex items-center gap-1.5 text-xs sm:text-sm py-2">
              <Bell className="w-3.5 h-3.5" />
              Notification<span className="hidden sm:inline"> Center</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="status">
            <SurgeonStatusTracker />
          </TabsContent>
          <TabsContent value="bundles">
            <BundleManagement />
          </TabsContent>
          <TabsContent value="credentials">
            <CredentialingVault />
          </TabsContent>
          <TabsContent value="comms">
            <CommunicationHub />
          </TabsContent>
        </Tabs>
      </div>
    </OpsLayout>
  );
}
